module.exports = __webpack_public_path__ + "img/sblr.02b55cf9.webp";